import React from 'react';

import styles from './ideaViewsListStyles';

import IdeaView from 'buyside/components/presentation/IdeaViewsPage/IdeaView/ideaView';

const IdeaViewsList = ({ views, ...viewProps }) => (
  <ul className={styles.viewsList}>
    {views.map((view, idx) => (
      <li className={styles.viewElement} key={idx}>
        <IdeaView view={view} {...viewProps} />
      </li>
    ))}
  </ul>
);

export default IdeaViewsList;
